import './App.css';
import Nav from './navigation/nav';
import React, { useEffect } from 'react';
import ReactGA from "react-ga4";
import PaymentReminder from './PaymentReminder';

// Initialize GA (yours already does this)
ReactGA.initialize('G-LLD6SHTYGK');

function App() {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Home Page",
    });
  }, []);

  return (
    <div>
      {/* Show the dialog once 7 days after deployment */}
      <PaymentReminder daysAfter={7} />

      <Nav />
    </div>
  );
}

export default App;